// Interruptor EN/ES. Mismo cuerpo que el de claro/oscuro de MusicPlayer: la
// ficha dorada se posa sobre el idioma activo.
import React from 'react';
import { setLang, useLang, useT } from '../i18n';

export default function LangToggle({ style }) {
  const lang = useLang();
  const t = useT();
  const es = lang === 'es';
  const label = (code, on) => (
    <span style={{
      position: 'relative', fontSize: 9.5, fontWeight: 800, letterSpacing: 0.4,
      fontFamily: 'sans-serif',
      color: on ? 'rgb(var(--c-1c0a0c))' : 'rgba(var(--c-e8c36a),0.55)',
      transition: 'color 0.25s',
    }}>{code}</span>
  );
  return (
    <button
      type="button"
      role="switch"
      aria-checked={es}
      aria-label={t('common.lang.label')}
      title={t('common.lang.switchTo')}
      onClick={() => setLang(es ? 'en' : 'es')}
      style={{
        position: 'relative', boxSizing: 'border-box', width: 58, height: 26,
        padding: '0 6px', borderRadius: 13, cursor: 'pointer',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        background: 'rgb(var(--c-1c0a0c))',
        border: '1px solid rgba(var(--c-c0a878),0.55)',
        boxShadow: 'inset 0 1px 3px rgba(var(--c-000000), calc(0.5 * var(--shade-k)))',
        ...style,
      }}
    >
      <span style={{
        position: 'absolute', top: 2, left: es ? 32 : 2, width: 22, height: 20, borderRadius: 10,
        background: 'linear-gradient(180deg, rgb(var(--c-f0d68a)), rgb(var(--c-c9a24e)))',
        boxShadow: '0 0 8px rgba(var(--c-e8c36a),0.5)',
        transition: 'left 0.25s ease',
      }} />
      {label('EN', !es)}
      {label('ES', es)}
    </button>
  );
}
